import { useEffect } from 'react';
import { useAppContext } from '../store/appContext';
import { SET_CURRENT_USER } from '../store/actions/types';
import { UserProfileInterface } from '../interfaces/user/UserInterfaces';

/**
 * Syncs the API user profile into the app store via SET_CURRENT_USER.
 * Centralises the mapping so any future field additions only need one change.
 *
 * @param user - The user profile from the API, or undefined when not yet loaded.
 * @param fallbackRole - Optional role to use when the API returns an empty userRole.
 */
export const useSyncCurrentUser = (
  user: UserProfileInterface | undefined,
  fallbackRole?: string,
) => {
  const { dispatch } = useAppContext();

  useEffect(() => {
    if (!user) return;

    dispatch({
      type: SET_CURRENT_USER,
      payload: {
        userId: user.userId,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.emailId,
        role: fallbackRole ? (user.userRole || fallbackRole) : user.userRole,
        privilegedMode: user.privilegedMode ?? false,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, fallbackRole]);
};
